<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :xl="16">
                <el-card shadow="never" class="MT20">
                    <el-row :gutter="30">
                        <el-col><span class="color-info">最近更新时间: </span>{{formData.updateTime}}</el-col>
                        <el-col><span class="color-info">申请性质: </span>{{formData.character == 1 ? '初次提交' : '二次提交'}} </el-col>
                    </el-row>
                    <el-row :gutter="30" class="MT10">
                        <el-col><span class="color-info">审核状态: </span>{{status.get(formData.status)}}</el-col>
                        <el-col><span class="color-info">审核人: </span>{{formData.reviewerUser}}</el-col>
                        <el-col><span class="color-info">审核时间: </span>{{formData.reviewerTime}}</el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props:{
        formData:{
            type: Object,
            default: null
        }
    },
    data(){
        return{}
    },
    computed:{
        status(){
            return new Map([
                [1,'待审核'],
                [2,'已通过'],
                [3,'已拒绝'],
                [4,'已撤销'],
            ])
        }
    }
}
</script>